// Propositions de newsletters prêtes à charger dans l'outil d'envoi Cocoon.
export const NEWSLETTER_TEMPLATES = [
  {
    id: "notes",
    label: "Les notes ont tué la curiosité",
    subject: "Les notes ont tué votre curiosité",
    body: `On nous a appris à apprendre pour la note, pas pour comprendre. Résultat : on a appris à éviter l'erreur au lieu de l'explorer.

## L'erreur n'est pas l'ennemie

Un enfant qui apprend à marcher tombe des dizaines de fois — personne ne lui met une mauvaise note. C'est l'inverse à l'école : une erreur devient une punition, et la curiosité se met en veille.

## Réapprendre à se tromper

Chez Cocoon, il n'y a ni note, ni classement, ni bonne réponse à deviner. Juste l'envie de comprendre pour de vrai. **La vraie question n'est pas « ai-je bon ? » mais « qu'est-ce que je viens d'apprendre ? »**`,
  },
  {
    id: "ennui",
    label: "L'ennui est un cadeau",
    subject: "L'ennui est un cadeau (qu'on a appris à fuir)",
    body: `On a rempli chaque seconde de vide avec un écran. Et si l'ennui était exactement le terreau des meilleures idées ?

## Le cerveau adore le vide

C'est dans les moments sans rien à faire que l'esprit relie, invente, s'étonne. Les grandes intuitions naissent rarement devant une notification.

## Osez ne rien faire

Cette semaine, laisse-toi un vrai moment d'ennui — sans écran. **Observe ce que ton esprit fabrique quand tu arrêtes de le nourrir.** C'est souvent là que commence la curiosité.`,
  },
  {
    id: "retenir",
    label: "Ne pas tout retenir",
    subject: "Vous n'avez pas besoin de tout retenir",
    body: `Pendant des siècles, savoir, c'était retenir. Aujourd'hui, tout se retrouve en trois secondes. Alors qu'est-ce qui compte encore ?

## Relier plutôt que réciter

La mémoire brute a perdu de sa valeur. Ce qui devient précieux, c'est la capacité à **relier** des idées, à juger ce qui est vrai, à donner du sens.

## Une tête bien faite

L'enjeu n'est plus une tête bien pleine, mais une tête bien faite : curieuse, critique, capable de tisser des liens là où les autres voient des faits isolés.`,
  },
  {
    id: "question",
    label: "Poser une bonne question",
    subject: "Poser une bonne question vaut mieux que connaître la réponse",
    body: `On récompense ceux qui répondent vite. Mais dans un monde où les réponses sont partout, c'est la qualité des questions qui fait la différence.

## L'art perdu du questionnement

Une bonne question ouvre dix portes ; une bonne réponse en ferme neuf. Les esprits les plus vifs ne sont pas ceux qui savent le plus, mais ceux qui demandent le mieux.

## Entraîne ton questionnement

La prochaine fois que tu crois « savoir », demande-toi : **et si c'était faux ? qu'est-ce que je ne vois pas ?** C'est exactement l'esprit du Feu du Doute.`,
  },
  {
    id: "diplome",
    label: "Le diplôme prouve l'obéissance",
    subject: "Le diplôme prouve que vous avez obéi, pas que vous avez compris",
    body: `Provocation ? Un peu. Mais regardons les choses en face : un diplôme mesure surtout votre capacité à faire ce qu'on attendait de vous, quand on l'attendait.

## Obéir n'est pas comprendre

On peut réussir un examen en oubliant tout la semaine suivante. On peut échouer en ayant réellement compris. Le système confond souvent conformité et intelligence.

## Comprendre pour soi

Chez Cocoon, aucune médaille à décrocher. **Le seul juge, c'est ta compréhension — et elle ne se triche pas.**`,
  },
  {
    id: "douter",
    label: "Apprendre à douter",
    subject: "Et si l'école apprenait à douter, pas à réciter ?",
    body: `On nous a appris des certitudes. On nous a rarement appris à les mettre à l'épreuve.

## Le doute, moteur de l'esprit

Douter, ce n'est pas être perdu : c'est refuser d'avaler une idée sans l'avoir regardée sous tous les angles. C'est la base de toute pensée libre.

## Mets tes certitudes à l'épreuve

Dans Le Feu du Doute, une voix prend systématiquement le contre-pied de tes convictions. Non pour te déstabiliser — **pour que tes idées ressortent plus solides, ou plus honnêtes.**`,
  },
  {
    id: "mots",
    label: "Trois mots qui ont changé le monde",
    subject: "Trois mots qui ont changé le monde sans qu'on s'en aperçoive",
    body: `Certains mots portent en eux des révolutions entières. On les utilise tous les jours sans en soupçonner l'histoire.

## Les mots gardent la mémoire

Derrière un mot banal se cache parfois un dieu oublié, une invention, une bataille. L'étymologie, c'est de l'archéologie de la pensée.

## Deviens explorateur de mots

Dans les Lexiques du Cocoon, chaque mot devient une porte : ses racines, son voyage, ses cousins inattendus. **Un mot compris, c'est un fragment du monde éclairé.**`,
  },
  {
    id: "verite",
    label: "Toute vérité a d'abord été ridicule",
    subject: "Toute vérité a d'abord été ridicule",
    body: `« Toute vérité franchit trois états : d'abord on la ridiculise, ensuite on la combat, enfin on l'accepte comme une évidence. » — Schopenhauer.

## Hier scandaleux, aujourd'hui banal

Que la Terre tourne autour du Soleil, que les femmes votent, que se laver les mains sauve des vies : chacune de ces évidences a d'abord fait rire, puis enrager.

## Quelle idée d'aujourd'hui est encore raillée ?

C'est la question que pose Les Trois Âges de la Vérité. **Peut-être qu'une idée moquée aujourd'hui sera l'évidence de demain.**`,
  },
  {
    id: "penser-ia",
    label: "Penser AVEC l'IA",
    subject: "5 façons de penser avec l'IA (au lieu de la laisser penser à votre place)",
    body: `L'IA peut t'endormir l'esprit… ou l'aiguiser. Tout dépend de comment tu t'en sers.

## 5 réflexes

**1.** Demande-lui de te contredire, pas seulement de t'approuver.
**2.** Fais-lui défendre l'avis inverse du tien.
**3.** Vérifie toujours : elle peut se tromper avec assurance.
**4.** Utilise-la pour explorer, pas pour conclure à ta place.
**5.** Garde le dernier mot — la nuance et le sens restent humains.

## L'IA amplifie, elle ne remplace pas

Bien utilisée, elle déplace ton effort du « faire » vers le « penser ». **À toi de rester le chef d'orchestre.**`,
  },
  {
    id: "lire",
    label: "Lire sans se faire avoir",
    subject: "Comment lire un article et ne pas se faire avoir",
    body: `Chaque jour, on nous présente des opinions déguisées en faits. Voici comment garder l'esprit clair.

## Trois questions à se poser

**Qui parle ?** Cherche l'auteur et ce qu'il a à gagner.
**Quelles preuves ?** Une affirmation forte demande des sources solides.
**Qu'est-ce qu'on ne me dit pas ?** Le plus trompeur est souvent l'angle mort.

## L'esprit critique, ça s'entraîne

Lire, ce n'est pas gober : c'est dialoguer avec le texte. **Doute, croise, vérifie — et forge ton propre avis.**`,
  },
  {
    id: "deborder",
    label: "Fais déborder le Cocoon ✨",
    subject: "Fais déborder le Cocoon",
    body: `Une idée qui reste dans ta tête s'éteint. Une idée qu'on partage prend feu.

## Le débat ne doit pas rester au Cocoon

Ce que tu explores ici — une conviction bousculée, une vérité retracée, une question qui dérange — mérite de vivre au-delà de l'écran. À table, entre amis, en famille.

## Transmets, provoque, écoute

Lance un des débats du Cocoon à ton prochain repas. Demande à un proche : **« Et toi, où penches-tu ? »** Tu verras — les plus belles conversations naissent souvent d'une simple question posée à voix haute.

## Le savoir se multiplie quand il se partage

Cocoon t'encourage à faire circuler ces idées dans ta relation, ta famille, ton entourage. **Une pensée partagée n'appartient plus à une seule tête : elle devient un lien.**`,
  },
  {
    id: "combustion",
    label: "Nous allumons des feux ✨ (nouveau)",
    subject: "Nous n'emplissons pas les têtes, nous allumons des feux",
    body: `Il existe une image simple pour comprendre comment on apprend vraiment. Pour qu'une **flamme** s'allume — un apprentissage qui dure — il faut trois éléments indissociables.

## Le carburant, le comburant, l'étincelle

**🔥 La curiosité, c'est le carburant.** L'élan intrinsèque de l'apprenant, sa soif de comprendre. Sans elle, il n'y a rien à brûler.

**💨 La ludification, c'est le comburant.** Le jeu, les défis, l'interactivité alimentent et intensifient la curiosité — l'étincelle devient un feu régulier.

**🛡️ Cocoon Mind, c'est l'étincelle et le cocon.** Un précepteur numérique qui initie et protège : un espace où l'échec n'est qu'un essai, où l'on ose s'éveiller.

## Pourquoi ça change tout

**On apprend par envie, pas par contrainte.** La curiosité devient le moteur : la rétention monte, l'effort perçu baisse. Le jeu entretient la flamme et maintient l'état de « flow », sans la fatigue du travail scolaire. Et l'IA ajuste tout sur mesure, selon la curiosité et la fatigue de chacun — fini le « taille unique ».

## Notre promesse en deux mots

Cocoon Mind ne gave pas les esprits : **nous allumons des feux.** La curiosité comme carburant, le jeu comme comburant. Notre promesse tient en deux mots : **Éveille-toi.**`,
  },
  {
    id: "ennui-creativite",
    label: "L'éloge de l'ennui ✨ (nouveau)",
    subject: "Et si l'ennui était le berceau de tes meilleures idées ?",
    body: `Ferme les yeux et souviens-toi de ton dernier moment de vrai ennui. Pas « je scrolle mon téléphone » — non, l'ennui *pur* : une salle d'attente sans réseau, un long trajet, le front contre la vitre. Ce moment-là, la science lui a donné un nom. Et elle affirme qu'il pourrait être l'un des états les plus précieux de ton cerveau.

## Le cerveau adore le vide

Quand rien ne réclame ton attention, ton cerveau n'éteint pas la lumière — au contraire. Il active un circuit appelé le **réseau du mode par défaut**. C'est le mode « rêverie » : ton esprit relie des souvenirs, imagine, résout des problèmes en arrière-plan. C'est là que surgit le fameux « Eurêka » — souvent sous la douche, jamais devant un écran.

## La preuve par l'expérience

Des chercheuses ont demandé à des volontaires une tâche d'une platitude absolue avant un test de créativité. Résultat : **les plus ennuyés ont été les plus inventifs.** L'ennui, comme une fringale, pousse l'esprit à *fabriquer* de la stimulation quand le monde ne lui en donne plus.

## Le vol qu'on ne voit pas

Le smartphone a fait disparaître les interstices — la file d'attente, l'ascenseur, l'arrêt de bus. On a comblé chaque miette de vide. Mais en tuant l'ennui, on a peut-être tué avec lui les moments où l'esprit vagabonde et invente. **On n'a pas gagné du temps : on a perdu de l'espace.**

## L'ennui n'est pas un échec, c'est une jachère

L'école t'a appris que l'ennui était une faute — « occupe-toi, remplis, sois productif ». Mais l'ennui est le terrain de repos de la pensée : un champ qu'on laisse dormir pour qu'il redevienne fertile.

## Ton défi de la semaine

Un « trajet nu » : un déplacement sans écouteurs, sans écran, sans rien. Juste toi et la fenêtre. Puis demande-toi — **quelle est la dernière idée qui t'est venue… en ne faisant rien ?**`,
  },
  {
    id: "silence",
    label: "Le silence n'existe pas ✨",
    subject: "Le silence total n'existe pas (et ça rend fou)",
    body: `Il existe sur Terre une pièce si silencieuse que personne n'y a jamais tenu plus d'une heure. On l'appelle une chambre anéchoïque, et ce qu'on y découvre est vertigineux.

## Le vide qui devient bruit

À l'intérieur, plus aucun son extérieur, plus aucun écho. Alors ton corps prend le relais : tu entends ton cœur battre, ton sang circuler, tes articulations craquer. Certains entendent même un léger sifflement — leur propre système nerveux.

## Pourquoi c'est troublant

Notre équilibre et notre repère dans l'espace s'appuient en partie sur les sons ambiants. Privé d'eux, le cerveau se désoriente, parfois jusqu'au malaise. Le « silence » que l'on cherche tant se révèle inhabitable.

## Ce que ça révèle

Le silence absolu n'est pas l'absence de bruit : c'est la découverte que **tu es toi-même une source de bruit permanente.** La quête du calme parfait est peut-être une illusion — et c'est justement ce qui la rend fascinante.`,
  },
  {
    id: "wood-wide-web",
    label: "Les arbres se parlent ✨",
    subject: "Sous la forêt, un internet vieux de millions d'années",
    body: `Une forêt n'est pas une collection d'arbres qui s'ignorent. C'est un réseau vivant, connecté sous tes pieds par un fil que la science surnomme le « Wood Wide Web ».

## Le rôle secret des champignons

Sous le sol, des filaments de champignons (les mycorhizes) relient les racines des arbres entre elles. À travers eux circulent de l'eau, du sucre, des nutriments — et même des signaux d'alerte.

## Des arbres solidaires

Un grand arbre peut nourrir un jeune plant à l'ombre, trop faible pour capter la lumière. Un arbre attaqué par des insectes peut « prévenir » ses voisins, qui renforcent alors leurs défenses. La forêt coopère bien plus qu'elle ne se fait la guerre.

## Le retournement

On a longtemps vu la nature comme une compétition impitoyable. Le Wood Wide Web raconte l'inverse : **la vie tient debout grâce à des liens invisibles.** Et si le vivant était d'abord une affaire de connexions ?`,
  },
  {
    id: "cleopatre",
    label: "Cléopâtre & l'iPhone ✨",
    subject: "Cléopâtre est plus proche de toi que des pyramides",
    body: `Voici une phrase qui fait vaciller notre sens du temps : Cléopâtre a vécu plus près de l'invention de l'iPhone que de la construction de la Grande Pyramide.

## Les chiffres qui dérangent

La Grande Pyramide de Gizeh a été bâtie vers 2560 av. J.-C. Cléopâtre est née en 69 av. J.-C. — soit près de 2 500 ans plus tard. Et il ne s'est écoulé « que » ~2 000 ans entre elle et nous. Elle est donc chronologiquement plus proche de nos smartphones que des pyramides qu'on associe pourtant à son époque.

## Pourquoi notre intuition se trompe

On empile mentalement « l'Antiquité » dans un même tiroir, comme si tout s'y était passé en même temps. Mais l'Histoire est faite d'immenses gouffres de temps que notre cerveau compresse par paresse.

## Ce que ça t'apprend

Notre perception du temps historique est une illusion d'optique. **Regarde une frise chronologique à l'échelle une fois — et tu ne verras plus jamais le passé de la même façon.**`,
  },
  {
    id: "chatouiller",
    label: "Se chatouiller soi-même ✨",
    subject: "Pourquoi tu ne peux pas te chatouiller toi-même",
    body: `Essaie, là, maintenant : chatouille-toi la plante du pied. Rien. Aucun fou rire. Pourtant la même sensation venue d'un ami te ferait bondir. Pourquoi ?

## Le cerveau qui prédit tout

Ton cerveau est une machine à anticiper. Avant même que ta main bouge, il prédit exactement la sensation qu'elle va produire — et l'atténue. Résultat : le signal est « attendu », donc désamorcé.

## La surprise, ingrédient secret

Le chatouillement repose sur l'imprévu. Quand quelqu'un d'autre te touche, ton cerveau ne peut pas prédire le geste : la surprise déclenche l'alerte, le rire, le réflexe. Sans imprévu, pas de chatouille.

## Le grand enseignement

Ce petit mystère révèle une vérité immense : **tu ne perçois pas le monde tel qu'il est, mais tel que ton cerveau l'a prédit.** Nous vivons en permanence dans une réalité anticipée — et ça, c'est vertigineux.`,
  },
  {
    id: "microbiome",
    label: "Qui est vraiment « toi » ? ✨",
    subject: "Tu es plus « eux » que « toi »",
    body: `Voici une idée qui bouscule l'ego : ton corps abrite des dizaines de milliers de milliards de bactéries. À tel point qu'on peut se demander qui, au juste, décide.

## Un peuple entier en toi

Ton intestin héberge un écosystème — le microbiote — aussi peuplé qu'une galaxie. Ces micro-organismes digèrent ce que tu ne peux pas, fabriquent des vitamines, entraînent ton système immunitaire.

## Ils influencent ton humeur

Plus surprenant : ces bactéries dialoguent avec ton cerveau. Elles participent à la production de molécules liées à l'humeur, au stress, à l'appétit. Ton « intuition » du ventre n'est pas qu'une image.

## La question qui reste

Si une part de tes envies, de ton énergie et de ton humeur naît de ce peuple invisible… **où finis-« tu » et où commencent-« ils » ?** L'identité est peut-être un dialogue, pas une forteresse.`,
  },
];
